import { Divider } from '@nextui-org/react';
import { CompanyInfoGrid } from '../molecules/CompanyInfoGrid';
import { formatDate } from '../../utils/formatters';

interface AboutSectionProps {
  vendorName: string;
  updatedAt: string | null;
  companyInfo: {
    name: string | null;
    founded: string | null;
    headquarters: string | null;
    employees: string | null;
    ownership: string | null;
    domain: string | null;
  };
  companyInformation: string | null;
  servicesAndProducts: string | null;
  className?: string;
}

export const AboutSection = ({
  vendorName,
  updatedAt,
  companyInfo,
  companyInformation,
  servicesAndProducts,
  className = '',
}: AboutSectionProps) => {
  // Transform companyInfo to match CompanyInfoGrid expected structure
  const companyInfoData = {
    company_name: companyInfo.name,
    founded: companyInfo.founded,
    headquarters: companyInfo.headquarters,
    no_of_employees: companyInfo.employees,
    ownership: companyInfo.ownership,
    primary_domain: companyInfo.domain,
  };

  const formattedDate = formatDate(updatedAt);

  return (
    <section className={`flex flex-col items-center p-4 gap-6 bg-white shadow-[0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_rgba(0,0,0,0.06)] rounded-lg flex-1 overflow-y-auto min-h-0 ${className}`}>
      {/* Section Header */}
      <div className="flex flex-row items-baseline gap-1 w-full">
        <h2 className="flex-1 font-['Inter'] font-medium text-sm leading-5 text-[#0F172B]">
          About {vendorName}
        </h2>
        <span className="font-['Inter'] font-normal text-xs leading-4 text-[#62748E]">
          Updated {formattedDate}
        </span>
      </div>

      {/* Company Info Grid */}
      <CompanyInfoGrid data={companyInfoData} className="w-full" />

      {/* Divider after company info */}
      <div className="w-full h-0 border-t border-[#E2E8F0]" />

      {/* Company Description or Empty State */}
      {companyInformation && companyInformation.trim() !== '' ? (
        <p className="w-full font-['Inter'] font-normal text-sm leading-5 text-[#314158]">
          {companyInformation}
        </p>
      ) : (
        <div className="flex flex-col items-center justify-center py-6 text-center">
          <p className="font-['Inter'] font-normal text-sm text-[#62748E]">
          No additional details available   
          </p>
        </div>
      )}
    </section>
  );
};
